module.exports = __webpack_public_path__ + "img/sl-4.webp";